import { NotificationsListPage } from "./NotificationsListPage";

export default function AdminNotificationsPage() {
  return <NotificationsListPage showCreate />;
}
